import React from "react"
import { Container, Button } from "react-bootstrap"

const FooterBanner = () => {
  return (
    <section className="footer-banner py-3 p-lg-5">
      <Container>
        <h1 className="rb text-center my-4">
          Subscribe to get our latest articles delivered straight to your inbox.
        </h1>
        <form className="d-flex flex-wrap justify-content-center align-items-center">
          <input type="text" placeholder="Enter your email here" />
          <Button className="filled-btn" size="lg">
            Subscribe
          </Button>
        </form>
      </Container>
    </section>
  )
}

export default FooterBanner
